import React, { useState } from "react";
import { api } from "./api";
import { Time } from "./time";

// Drafts a report to the authority that can act on an item (npm, PyPI, MCP Registry, GitHub). HerdSafe sends
// nothing: copy the draft, send it yourself, then record it here. Drafting and recording are audited.
export default function UpstreamReportPanel({ itemId, styles }) {
  const [res, setRes] = useState(null);
  const [msg, setMsg] = useState("");
  const [notes, setNotes] = useState({});

  const draft = async () => {
    setMsg("");
    try { setRes((await api.upstreamDrafts(itemId)).data); } catch (ex) { setMsg("Error: " + ex.message); }
  };
  const copy = async (d) => {
    try { await navigator.clipboard.writeText(`Subject: ${d.subject}\n\n${d.body}`); setMsg(`Copied the ${d.name} draft.`); }
    catch (_) { setMsg("Copy failed: select the text and copy it by hand."); }
  };
  const sent = async (d) => {
    try { await api.upstreamSent(itemId, d.authority, notes[d.authority] || ""); setMsg(`Recorded: sent to ${d.name}.`); draft(); }
    catch (ex) { setMsg("Error: " + ex.message); }
  };
  const mailto = (d) => `mailto:${d.email}?subject=${encodeURIComponent(d.subject)}&body=${encodeURIComponent(d.body)}`;

  return (
    <div style={styles.card} data-testid="upstream-panel">
      <h3 style={{ marginTop: 0 }}>Report upstream</h3>
      <p style={{ fontSize: 12, color: "var(--hs-text-muted)", marginTop: 0 }}>
        Drafts a report with the evidence for the registry or host that can take the item down. Nothing is sent
        automatically. Check that each channel is still current before you send.
      </p>
      <button type="button" style={styles.btn} onClick={draft} data-testid="upstream-draft">{res ? "Redraft" : "Draft reports"}</button>
      {res && res.note && <div style={{ fontSize: 12, marginTop: 8 }}>{res.note}</div>}
      {res && res.drafts.map((d) => (
        <div key={d.authority} style={{ borderTop: "1px solid var(--hs-border)", marginTop: 12, paddingTop: 12 }} data-testid={`upstream-${d.authority}`}>
          <strong>{d.name}</strong>
          <div style={{ fontSize: 12, color: "var(--hs-text-muted)" }}>{d.how}</div>
          <div style={{ ...styles.row, marginTop: 6 }}>
            {d.web && <a className="hs-link" href={d.web} target="_blank" rel="noopener noreferrer">Open {new URL(d.web).host}</a>}
            {d.email && <a className="hs-link" href={mailto(d)}>Email {d.email}</a>}
            <button type="button" style={styles.btnDim} onClick={() => copy(d)}>Copy draft</button>
          </div>
          <div style={{ fontSize: 12, marginTop: 6 }}>Subject: {d.subject}</div>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, maxHeight: 260, overflow: "auto", background: "var(--hs-code-bg)", padding: 8 }}>{d.body}</pre>
          <div style={styles.row}>
            <input style={{ ...styles.input, minWidth: 220 }} placeholder="Ticket / note (optional)" value={notes[d.authority] || ""}
              onChange={(e) => setNotes({ ...notes, [d.authority]: e.target.value })} aria-label={`Note for ${d.name}`} />
            <button type="button" style={styles.btnDim} onClick={() => sent(d)} data-testid={`upstream-sent-${d.authority}`}>I sent it</button>
          </div>
        </div>
      ))}
      {res && res.sent.length > 0 && (
        <ul style={{ fontSize: 12, marginTop: 12 }} data-testid="upstream-history">
          {res.sent.map((s, i) => <li key={i}><Time value={s.sent_at} dateOnly /> · {s.authority} · {s.actor}{s.note ? ` · ${s.note}` : ""}</li>)}
        </ul>
      )}
      {msg && <div style={{ fontSize: 12, color: "var(--hs-text-muted)", marginTop: 6 }}>{msg}</div>}
    </div>
  );
}
